"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uid = require("../utils/uid");

var _component = require("../component");

var _tree = require("../utils/tree");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(_class, _Component);

    function _class(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.state = {
        filterText: '',
        filter: null
      };
      return _this;
    }

    var _proto = _class.prototype;

    _proto.getData = function getData() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          childrenKey = _this$props.childrenKey,
          keygen = _this$props.keygen;
      var filter = this.state.filter;
      if (!filter) return data;
      return (0, _tree.getFilterTree)(data, filter, undefined, function (node) {
        return (0, _uid.getKey)(node, keygen);
      }, childrenKey, true, function (node) {
        if (_this2.firstMatchNode) return;
        _this2.firstMatchNode = node;
      });
    };

    _proto.handleFilter = function handleFilter(filterText) {
      var _this3 = this;

      var _this$props2 = this.props,
          filterDelay = _this$props2.filterDelay,
          onFilter = _this$props2.onFilter;
      if (this.timer) clearTimeout(this.timer);
      this.firstMatchNode = null;

      if (filterText.length === 0) {
        this.setState({
          filter: null,
          filterText: filterText
        });
        return;
      }

      this.timer = setTimeout(function () {
        var fn = onFilter(filterText);

        if (typeof fn === 'function') {
          _this3.setState({
            filter: fn,
            filterText: filterText
          });
        }
      }, filterDelay);
    };

    _proto.render = function render() {
      var onFilter = this.props.onFilter;
      var _this$state = this.state,
          filterText = _this$state.filterText,
          filter = _this$state.filter;
      if (!onFilter) return _react.default.createElement(Origin, this.props);
      var data = this.getData();
      return _react.default.createElement(Origin, _extends({}, this.props, {
        data: data,
        filterText: filterText,
        onFilter: this.handleFilter,
        filterDataChange: filter,
        firstMatchNode: this.firstMatchNode
      }));
    };

    return _class;
  }(_component.Component), _defineProperty(_class, "propTypes", {
    onFilter: _propTypes.default.func,
    filterDelay: _propTypes.default.number,
    data: _propTypes.default.array,
    childrenKey: _propTypes.default.string,
    keygen: _propTypes.default.any,
    mode: _propTypes.default.number
  }), _defineProperty(_class, "defaultProps", {
    filterDelay: 400
  }), _temp;
};

exports.default = _default;